// Notification utilities for browser push notifications
export const requestNotificationPermission = async () => {
  if (!('Notification' in window)) {
    
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  return false;
};

export const showNotification = (title, options = {}) => {
  if (Notification.permission === 'granted') {
    const notification = new Notification(title, {
      icon: '/logo192.png',
      badge: '/logo192.png',
      ...options
    });

    // Auto-close after 5 seconds
    setTimeout(() => {
      notification.close();
    }, 5000);

    return notification;
  }
  return null;
};

export const showAssignmentReminder = (assignment, hoursUntilDue) => {
  const title = `Assignment Due Soon: ${assignment.title}`;
  const body = `Due in ${hoursUntilDue} hour${hoursUntilDue !== 1 ? 's' : ''}`;

  showNotification(title, {
    body,
    tag: `assignment-${assignment._id}`,
    requireInteraction: false
  });
};